import { AlertTriangle, CheckCircle2, Info, OctagonAlert } from "lucide-react";
import type { LucideIcon } from "lucide-react";

import { DocsRichTextView } from "@/presentation/components/docs/docs-rich-text";
import type {
  DocsCalloutBlock,
  DocsCalloutTone,
} from "@/presentation/data/docs/docs-content.types";

interface DocsCalloutProps {
  block: DocsCalloutBlock;
}

interface ToneStyle {
  icon: LucideIcon;
  className: string;
  iconClassName: string;
}

const TONE_STYLE: Record<DocsCalloutTone, ToneStyle> = {
  info: {
    icon: Info,
    className: "border-[oklch(0.55_0.17_190_/_0.3)] bg-[oklch(0.55_0.17_190_/_0.06)]",
    iconClassName: "text-[oklch(0.5_0.17_190)]",
  },
  warn: {
    icon: AlertTriangle,
    className: "border-[oklch(0.74_0.16_80_/_0.4)] bg-[oklch(0.74_0.16_80_/_0.08)]",
    iconClassName: "text-[oklch(0.58_0.14_70)]",
  },
  danger: {
    icon: OctagonAlert,
    className: "border-[oklch(0.62_0.22_25_/_0.35)] bg-[oklch(0.62_0.22_25_/_0.07)]",
    iconClassName: "text-[oklch(0.55_0.2_25)]",
  },
  success: {
    icon: CheckCircle2,
    className: "border-[oklch(0.66_0.16_155_/_0.4)] bg-[oklch(0.66_0.16_155_/_0.07)]",
    iconClassName: "text-[oklch(0.5_0.15_155)]",
  },
};

export function DocsCallout({ block }: DocsCalloutProps) {
  const tone = TONE_STYLE[block.tone];
  const Icon = tone.icon;
  return (
    <aside className={`my-4 flex gap-3 rounded-lg border px-4 py-3 ${tone.className}`}>
      <Icon className={`mt-0.5 size-4 shrink-0 ${tone.iconClassName}`} />
      <div className="min-w-0 text-sm leading-relaxed">
        {block.title ? <p className="text-foreground mb-0.5 font-semibold">{block.title}</p> : null}
        <p className="text-muted-foreground">
          <DocsRichTextView value={block.text} />
        </p>
      </div>
    </aside>
  );
}
